import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import updateArrayMember from "@Array/updateArrayMember";
import {
    setCheckOrderData,
    setCheckOrderDataFromUser,
    setCheckOrderFatalError
} from "@CheckOrder/reducers/checkOrderSlice";
import UserType from "@CheckOrder/types/User.type";
import {setUser} from "@MyProfile/reducers/userProfileSlice";
import {
    GetCheckOrderDataRequestType,
    GetCheckOrderDataResponseType
} from "@CheckOrder/api/types/GetCheckOrderDataQuery.type";
import {setError} from "@Reducers/pageSlice";
import getGetCheckOrderDataUrl from "@CheckOrder/api/functions/getGetCheckOrderDataUrl";

export default function getCheckOrderDataQuery(): OnQueryStartedFunctionAttrType<GetCheckOrderDataRequestType, GetCheckOrderDataResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        try {
            const response = await queryFulfilled
            if (response.meta.response.ok && response.data.checkOrder) {
                const {
                    checkOrder,
                } = response.data

                const {
                    passengers: passengersList,
                    user,
                } = checkOrder
                if (request.firstUser && !user) {
                    const passengers = updateArrayMember(passengersList, 0, '', request.firstUser, true)
                    const mergedData = {
                        ...checkOrder,
                        passengers,
                    }
                    dispatch(setCheckOrderData(mergedData))
                } else {
                    dispatch(setCheckOrderData(checkOrder))
                }
                if (user) {
                    const mergedUser: UserType = {...user, ...checkOrder.user}
                    dispatch(setUser(mergedUser))
                    dispatch(setCheckOrderDataFromUser(mergedUser))
                }

                return;
            }
            dispatch(setCheckOrderFatalError(true))
            dispatch(setError({
                error: "check order data fetch failed",
                info: `failed url: ${getGetCheckOrderDataUrl()}`,
            }))
        } catch (err) {
            dispatch(setCheckOrderFatalError(true))
            dispatch(setError({
                error: "check order data fetch failed",
                info: `failed url: ${getGetCheckOrderDataUrl()}`,
            }))
        }
    }
}